export const config = {
  apiBaseUrl: 'staging.api.doss.com',
  protocol: 'https',
  websocketProtocol: 'wss',
  isProduction: false,
  isStaging: true,
}
